<template>
	<div id="foot-item" class="foot">
		<table border="0" width="80%" height="100%" class="foot_table">
			<tr>
				<td >
					<div class="foot_info" align="left">
						<h2>关于我们 </h2>
						<h3>我们致力于在产品设计、制造、服务领域，为制造业客户提供一站式、高效的卓越产品与解决方案，凭借着超过20年的专业行业经验，我们已为超过1300多家客户提供服务，覆盖多个行业领域。</h3>
						<h3 class="info-left_text1">掌握模型轻量化与简化的核心技术，能够支持多种CAD数据格式转换，确保您的数据在转换过程中高效且可控，实现了对PIV数据格式的高效转换，并开发出了一系列完全自主的产品。</h3>
						<h3 class="info-left_text2">TundraViewer是一款专业的可视化工具，为工艺、制造、销售、培训、支付、运维等多个应用场景提供全面的解决方案，积极参与DISA联盟与业界共同合作，致力于《三维CAD模型轻量化格式》团体标准的制定与推进。</h3>
						<img src="../../assets/img/logo/3dmodel_white.png" style="width: 150px;">
					</div>
				</td>
				<td>
					<div class="foot_info" align="left">
						<h2>联系我们 </h2>
						<h3>热线：4006209980</h3>
						<h3>总机：021-56559988</h3>
						<h3>地址：上海市闵行区号文路72弄5号(宝龙广场T7)801室</h3>
					</div>
				</td>
				<td>
					<div align="left" class="foot_qr" >
						<div class="qr_info">
							<img src="../../assets/img/foot/pisx_QR.jpg" alt=""  class="foot_marginto">
							<h2>关注我们</h2>
							<h3>扫码关注公众号，获取最新动态</h3>
						</div>
					</div>
				</td>
			</tr>
			<tr>
				<td colspan="3">
					<hr class="foot_marginto">
					<div>
						<h3>Copyright © 2021 上海湃睿信息科技有限公司</h3>
					</div>
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
	export default {
		name: "FootItem"
	}
</script>

<style scoped lang="less">

</style>
